import client1 from "../../assets/img/clients/clients-1.webp";
import client2 from "../../assets/img/clients/clients-2.webp";
import client3 from "../../assets/img/clients/clients-3.webp";
import client4 from "../../assets/img/clients/clients-4.webp";
import client5 from "../../assets/img/clients/clients-5.webp";
import client6 from "../../assets/img/clients/clients-6.webp";
import kwalitywalls from "../../assets/img/clients/kwalityWalls.avif";
import creambell from "../../assets/img/clients/creambells.avif";
import motherdairy from "../../assets/img/clients/motherDairy.avif";
import amul from "../../assets/img/clients/amul.avif";
import rockLick from "../../assets/img/clients/rocklick.avif";
import v3 from "../../assets/img/clients/v3.avif";
import londondairy from "../../assets/img/clients/londonDairy.avif";
import heritage from "../../assets/img/clients/heritage.avif";
import vadilal from "../../assets/img/clients/vadilal.avif";
import namasteindia from "../../assets/img/clients/namasteindia.avif";
import sheetal from "../../assets/img/clients/sheetal.avif";
import havemor from "../../assets/img/clients/havemor.avif";
import superhf from "../../assets/img/clients/super.avif";
import sudha from "../../assets/img/clients/sudha.avif";
import hocco from "../../assets/img/clients/hocco.gif";
import elanpro from "../../assets/img/clients/elanpro.avif";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

const Clients = () => {
  const clients = [
    { src: amul, alt: "amul", delay: 100 },
    { src: creambell, alt: "creambell", delay: 150 },
    { src: havemor, alt: "havemor", delay: 200 },
    { src: hocco, alt: "hocco", delay: 250 },
    { src: kwalitywalls, alt: "kwalitywalls", delay: 300 },
    { src: londondairy, alt: "londondairy", delay: 350 },
    { src: motherdairy, alt: "motherdairy", delay: 400 },
    { src: namasteindia, alt: "namasteindia", delay: 450 },
    { src: rockLick, alt: "rockLick", delay: 500 },
    { src: vadilal, alt: "vadilal", delay: 550 },
    { src: v3, alt: "v3", delay: 600 },
    { src: heritage, alt: "heritage", delay: 650 },
    { src: sheetal, alt: "sheetal", delay: 700 },
    { src: superhf, alt: "superhf", delay: 750 },
    { src: sudha, alt: "sudha", delay: 800 },
    { src: elanpro, alt: "elanpro", delay: 850 },
  ];

  return (
    <div className="">
      <section
        id="clients"
        className="testimonials section bg-secondary-subtle  bg-opacity-25"
      >
        <div className="container " data-aos="fade-up" data-aos-delay="100">
          <div className="container section-title" data-aos="fade-up">
            <h4 className="subtitle">Few of our Clients</h4>
          </div>
          {/* <div className="row gy-4">
            {clients.map((client, index) => (
              <div
                key={index}
                className="col-xl-2 col-lg-3 col-md-4 col-6"
                data-aos="zoom-in"
                data-aos-delay={client.delay}
              >
                <div
                  className="client-item d-flex align-items-center justify-content-center"
                  style={{ height: "120px" }}
                >
                  <img
                    src={client.src}
                    className="img-fluid"
                    alt={client.alt}
                    style={{ maxHeight: "100%", objectFit: "contain" }}
                  />
                </div>
              </div>
            ))}
          </div> */}

          <div className="container" data-aos="fade-up" data-aos-delay="100">
            <Swiper
              className="swiper"
              modules={[Autoplay, Pagination]}
              loop={true}
              speed={600}
              autoplay={{ delay: 5000 }}
              pagination={{ clickable: true }}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                  spaceBetween: 40,
                },
                1200: {
                  slidesPerView: 3,
                  spaceBetween: 20,
                },
              }}
            >
              {clients?.map((testimonial, index) => (
                <SwiperSlide key={index}>
                  <div
                    className="testimonial-item "
                    style={{
                      width: "200px", // or any fixed size you want
                      height: "200px",
                      margin: "0 auto", // center the div
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src={testimonial.src}
                      alt={testimonial.alt}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                        transitionDelay: `${testimonial.delay}ms`,
                      }}
                      className="rounded"
                    />
                  </div>
                </SwiperSlide>
              ))}

              {/* {clients?.map((testimonial, index) => (
                <SwiperSlide key={index}>
                  <div className="testimonial-item">
                    <img
                      src={testimonial.src}
                      className=""
                      alt={testimonial.name}
                      style={{
                        width: "100%",
                        objectFit: "contain",
                        transitionDelay: `${testimonial.delay}ms`,
                      }}
                    />
                  </div>
                </SwiperSlide>
              ))} */}
            </Swiper>

            {/* Pagination bullets */}
            <div className="swiper-pagination mt-3"></div>
          </div>
        </div>
      </section>

      {/* <section className="py-5 ">
        <div className="container " data-aos="fade-up" data-aos-delay="100">
          <div className="d-flex flex-column flex-md-row align-items-center">
            <div className="text-start flex-grow-1 pe-md-4">
              <h6
                className="text-uppercase fw-bold mb-3"
                style={{ letterSpacing: "0.2em" }}
              >
                DONUT HELLO
              </h6>

              <div
                className="w-[60px] h-[60px] flex items-center justify-center rounded-full mb-6 text-[1.75rem]"
                style={{
                  backgroundColor:
                    "color-mix(in srgb, #c85716, transparent 90%)",
                  color: "#c85716",
                }}
              >
                <i className="bi bi-quote"></i>
              </div>

              <blockquote className="blockquote mb-4">
                <p className="fs-5 fst-italic">
                  “Ferla Bikes is the perfect fit for what we wanted to happen
                  in our business. Not only do they produce top of the line
                  bikes, but the service that Ferla team provides is second to
                  none.”
                </p>
              </blockquote>

              <p
                className="text-muted mb-1 text-uppercase small"
                style={{ letterSpacing: "0.1em" }}
              >
                PAOLO SEEN
              </p>
              <p className="fw-semibold" style={{ color: "#AF9A7D" }}>
                CEO at Donut Hello – San Diego, CA
              </p>
            </div>

            <div>
              <img
                src="https://static.wixstatic.com/media/ee43e9_b63a410434fc4553873f8789443c2bee~mv2.jpeg"
                alt="Paolo Seen"
                className="rounded-circle"
                width="141"
                height="141"
                style={{ objectFit: "cover" }}
              />
            </div>
          </div>
        </div>
      </section> */}
    </div>
  );
};

export default Clients;
